import React, { useState, useContext, useEffect } from "react";
import "../../../css/CRUDModal.css";
import DeleteConfirmationModal from "../DeleteConfirmationModal";
import axios from "axios";
import { BankNameContext } from "../../../context/BankNameContext";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {apiList, baseAuthUrl, baseUrl} from "../../../helpers/apiList";
import { axiosGetApi } from "../../../helpers/interceptorServices";
import AadhaarInput from "../../common/AadhaarInput";
import { FaEye } from "react-icons/fa";
import PanInput from "../../common/PanInput";
import Dropdown from "../../Dropdown";

const AddCustomer = ({
  show,
  handleClose,
  editData,
  action,
  fetchCustomerData,
  payloadData,
  setPayloadData,
  loggedInUserName,
  CloseCreate,
  handleNext,
  hubList,
}) => {
  // const loggedInUserName = sessionStorage.getItem("username");

  const [errors, setErrors] = useState({
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    bankName: "",
    accountNo: "",
    ifscCode: "",
    gstNumber: "",
    aadharNumber: "",
    panNumber: "",
    companyPanNumber: "",
    companyType: "",
    hubCode: "",
    lmbpBusinessType: "",
    rateCardId: "",
    isEcommerce: "",
    masterLmbpCode: "",
    hierarchyType: "",
    margin: "",
    marginCompanyShare: "",
    parentType: "",
  });
  const { bankNames, loading, error } = useContext(BankNameContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [validGSTNo, setValidGSTNo] = useState(false);
  const [validCompanyPanNo, setValidCompanyPanNo] = useState(false);
  const [cardOptions, setCardOptions] = useState([]);

  // ----------------- added this -----------------
  const [showDocModal, setShowDocModal] = useState(false);
  const [docPath, setDocPath] = useState("");
  const [docLabel, setDocLabel] = useState("");
  const [docMime, setDocMime] = useState("");
  const [activeDoc, setActiveDoc] = useState("GST");
  const [gstApproved, setGstApproved] = useState(false);
  const [panApproved, setPanApproved] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  // ----------------------- LMBP Type --------------------
  const [lmbpList, setLmbpList] = useState([]);
  

  // Start dragging
  const handleMouseDown = (e) => {
    if (zoomLevel <= 1) return; // only allow drag when zoomed in
    setIsDragging(true);
    setDragStart({ x: e.clientX - offset.x, y: e.clientY - offset.y });
    e.preventDefault();
  };

  // Move document
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const newX = e.clientX - dragStart.x;
    const newY = e.clientY - dragStart.y;
    setOffset({ x: newX, y: newY });
  };

  // Stop dragging
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  React.useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [isDragging, dragStart]);

  // TODO call 2 api same time
  React.useEffect(() => {
    if (action === "modify") {
      fetchRateCardData(); // load dropdown data
    }
  }, [action]);

  useEffect(() => {
    fetchActiveLmbpData();
  }, []);

  if (loading) {
    return <p>Loading data...</p>;
  }

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "isEcommerce") {
      updatedValue = value === "Yes";
    }

    if (
      id === "name" ||
      id === "ifscCode" ||
      id === "gstNumber" ||
      id === "panNumber" ||
      id === "companyPanNumber"
    ) {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (
      id === "firstContactPersonMobileNo" ||
      id === "secondContactPersonMobileNo" ||
      id === "accountNo"
    ) {
      updatedValue = value.replace(/[^0-9]/g, "");
    } else if (id === "margin" || id === "marginCompanyShare") {
  // Allow only numbers with up to 2 decimal places
  if (/^\d{0,3}(\.\d{0,2})?$/.test(value)) {
    // Margin is capped at 30%, the company share at 100%
    if (value === "" || Number(value) <= (id === "margin" ? 30 : 100)) {
      updatedValue = value;
    } else {
      return; // Ignore values > 100
    }
  } else {
    return; // Ignore invalid input
  }
}

    setPayloadData((prev) => {
      const newPayload = { ...prev, [id]: updatedValue };

      if (id === "gstNumber") {
        if (updatedValue.length === 15) {
          const derivedPan = updatedValue.slice(2, 12);
          newPayload.companyPanNumber = derivedPan;
        } else {
          newPayload.companyPanNumber = "";
        }
      }

      // Set default margin when Hierarchy Type is SUB
   if (id === "hierarchyType") {
     if (updatedValue === "SUB") {
       newPayload.margin = prev.margin || 10;
       newPayload.parentType = ""; // Let user choose
     } else if(updatedValue === "MASTER") {
       newPayload.margin = prev.hierarchyType === "SUB" ? 0 : prev.margin ?? 0;
       newPayload.masterLmbpCode = "";
       newPayload.parentType = "HUB"; // Auto select HUB
     }
   }

      return newPayload;
    });


    if (id === "pinCode") {
      validatePinCode(value);
    }

    if (id === "companyType") {
      const trimmedValue = updatedValue.trim();
      const isValidAuthPerPan =
        trimmedValue === "Private Limited" ||
        trimmedValue === "Public Limited" ||
        trimmedValue === "LLP";

      setErrors((prevErrors) => ({
        ...prevErrors,
        panNumber:
          isValidAuthPerPan &&
          payloadData?.companyPanNumber === payloadData?.panNumber
            ? "LMBP PAN and Authorised PAN must be different"
            : "",
      }));
    }
  };

  const handleNextWithValidation = () => {
    const validationErrors = validate();
    setErrors(validationErrors);
    console.log(":: validationErrors ::", validationErrors)

    // If there are no validation errors, proceed to next step
    if (
      Object.keys(validationErrors).length === 0 ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      (action === "modify" && !payloadData.aadharNumberRaw)
    ) {
      handleNext(); // Call the original handleNext function
    } else {
      // Show error message or toast notification
      toast.error("Please fix all validation errors before proceeding", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Scroll to first error field
      const firstErrorField = document.querySelector(".error");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    payloadData.name = (payloadData.name || "").trim(); // may be null on older records
    if (!payloadData.name) {
      newErrors.name = "LMBP Name is required";
    } else if (
      // !/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(payloadData.name) ||
      !/^[A-Za-z0-9@&.,'\- ]+$/.test(payloadData.name) ||
      payloadData.name.length < 2 ||
      payloadData.name.length > 50
    ) {
      newErrors.name =
        "LMBP name must be valid and between 2 and 50 characters";
    } else if (/^(.)\1{2,}$/.test(payloadData.name)) {
      newErrors.name =
        "LMBP name cannot be made of a single repeated character";
    }

    // Email validation (required and valid email)
    if (!payloadData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
        payloadData.emailId,
      ) ||
      /\.com\./.test(payloadData.emailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(payloadData.emailId)
    ) {
      newErrors.emailId = "Enter valid email ending with .com .co.xx or .in";
    }

    // Address validation
    payloadData.address1 = (payloadData.address1 || "").trim(); // may be null on older records
    if (!payloadData.address1) {
      newErrors.address1 = "Address is required";
    } else if (
      payloadData.address1.length < 5 ||
      payloadData.address1.length > 150
    ) {
      newErrors.address1 = "Address1 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.address1,
      )
    ) {
      newErrors.address1 =
        "Address 1 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address1)) {
      newErrors.address1 = "Address 1 must contain at least one letter";
    }

    // Address 2 validation (required)
    payloadData.address2 = (payloadData.address2 || "").trim(); // may be null on older records
    if (!payloadData.address2) {
      newErrors.address2 = "Address is required";
    } else if (
      payloadData.address2.length < 5 ||
      payloadData.address2.length > 150
    ) {
      newErrors.address2 = "Address2 must be between 5 and 50 characters";
    } else if (
      !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
        payloadData.address2,
      )
    ) {
      newErrors.address2 =
        "Address 2 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address2)) {
      newErrors.address2 = "Address 2 must contain at least one letter";
    }

    // Address 3 validation (optional)
    payloadData.address3 = (payloadData.address3 || "").trim(); // may be null on older records
    if (payloadData.address3) {
      if (
        payloadData.address3.length < 5 ||
        payloadData.address3.length > 150
      ) {
        newErrors.address3 = "Address 3 must be between 5 and 150 characters";
      } else if (
        !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
          payloadData.address3,
        )
      ) {
        newErrors.address3 =
          "Address 3 contains invalid characters or starts/ends with spaces";
      } else if (!/[A-Za-z]/.test(payloadData.address3)) {
        newErrors.address3 = "Address 3 must contain at least one letter";
      }
    }
    if (!payloadData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(payloadData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // First contact person name validation (between 2 and 50 characters)
    payloadData.firstContactPersonName =
      (payloadData.firstContactPersonName || "").trim();
    if (!payloadData.firstContactPersonName) {
      newErrors.firstContactPersonName = "Contact person name is required";
    } else if (
      !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
      payloadData.firstContactPersonName.length < 2 ||
      payloadData.firstContactPersonName.length > 50
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must be between 2 and 50 characters and contain only letters";
    } else if (
      !/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(payloadData.firstContactPersonName)
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(
        payloadData.firstContactPersonName.replace(/[ .-]/g, ""),
      )
    ) {
      newErrors.firstContactPersonName =
        "Contact person name cannot consist of the same letter repeated";
    }

    // First contact person mobile number validation
    if (!payloadData.firstContactPersonMobileNo) {
      newErrors.firstContactPersonMobileNo =
        "Contact person mobile number is required";
    } else if (!/^[6789]\d{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
    } else if (/^(\d)\1{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot have all repeated digits";
    } else if (
      payloadData.firstContactPersonMobileNo === "1234567890" ||
      payloadData.firstContactPersonMobileNo === "9876543210"
    ) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot be a simple sequence";
    }

    // Aadhar Number Validation
    const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";
    if (!aadharRaw) {
      newErrors.aadharNumber = "Aadhar Number is required";
    } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber =
        "Aadhar Number must be exactly 12 digits and start with 2-9";
    } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber = "Aadhar Number cannot have all repeated digits";
    }

    // PAN Number Validation
    // if (!payloadData.panNumber) {
    //   newErrors.panNumber = "PAN Number is required";
    // } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.panNumber)) {
    //   newErrors.panNumber = "Invalid PAN Number format";
    // }
    const panRaw = payloadData?.panNumberRaw?.trim() || "";

    if (!panRaw) {
      newErrors.panNumber = "PAN Number is required";
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panRaw)) {
      newErrors.panNumber = "Invalid PAN Number format";
    }

    // LMBP PAN Number Validation (Optional)
    if (
      payloadData.companyPanNumber &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.companyPanNumber)
    ) {
      newErrors.companyPanNumber = "Invalid PAN Number format";
    }

    // LMBP Type validation
    if (!payloadData.companyType) {
      newErrors.companyType = "LMBP Type is required";
    }

    if (!payloadData.lmbpBusinessType) {
      newErrors.lmbpBusinessType = "LMBP Business Type is required";
    }

    if (!payloadData.hubCode && payloadData?.hierarchyType !== "SUB") {
      newErrors.hubCode = "HUB Type is required";
    }

    if (!payloadData.parentType) {
      newErrors.parentType = "Parent Type is required";
    }

    if (!payloadData.rateCardId) {
      newErrors.rateCardId = "Rate Card Type is required";
    }

    if (
      payloadData.isEcommerce === "" ||
      payloadData.isEcommerce === undefined ||
      payloadData.isEcommerce === null
    ) {
      newErrors.isEcommerce = "Ecommerce selection is required";
    }

    if (!payloadData.masterLmbpCode && (payloadData?.hierarchyType === "SUB" && payloadData?.parentType === "LMBP")) {
      newErrors.masterLmbpCode = "Master LMBP Name is required";
    }

    if (!payloadData.hierarchyType) {
      newErrors.hierarchyType = "Hierarchy Type is required";
    }

    // Margin (%) on freight: required for a sub-LMBP, optional for a master; 0-30%
    const marginEmpty = payloadData.margin === "" || payloadData.margin == null;
    if (marginEmpty && payloadData?.hierarchyType === "SUB") {
      newErrors.margin = "Margin is required";
    } else if (!marginEmpty && !/^\d{1,2}(\.\d{1,2})?$/.test(String(payloadData.margin))) {
      newErrors.margin = "Margin can have up to 2 decimal places";
    } else if (!marginEmpty && (Number(payloadData.margin) < 0 || Number(payloadData.margin) > 30)) {
      newErrors.margin = "Margin must be between 0 and 30%";
    }
    if (payloadData?.hierarchyType === "SUB") {
      const share = payloadData.marginCompanyShare;
      if (share === "" || share == null) {
        newErrors.marginCompanyShare = "Company share is required";
      } else if (Number(share) < 0 || Number(share) > 100) {
        newErrors.marginCompanyShare = "Company share must be between 0 and 100%";
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value.trim();

    switch (id) {
      case "name":
        if (!trimmedValue) {
          fieldErrors.name = "LMBP Name is required";
        } else if (
          !/^[A-Za-z0-9@&.,'\- ]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.name =
            "LMBP name must be valid and between 2 and 50 characters";
        } else if (/^(.)\1{2,}$/.test(trimmedValue)) {
          fieldErrors.name =
            "LMBP name cannot be made of a single repeated character";
        } else {
          fieldErrors.name = ""; // ✅ Clear error if valid
        }
        break;

      case "emailId":
        if (!trimmedValue) {
          fieldErrors.emailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
            trimmedValue,
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.emailId =
            "Enter valid email ending with .com .co.xx or .in";
        } else {
          fieldErrors.emailId = "";
        }
        break;

      case "address1":
        if (!trimmedValue) {
          fieldErrors.address1 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address1 =
            "Address 1 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.address1 =
            "Address 1 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address1 = "Address 1 must contain at least one letter";
        } else {
          fieldErrors.address1 = "";
        }
        break;

      case "address2":
        if (!trimmedValue) {
          fieldErrors.address2 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address2 =
            "Address 2 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.address2 =
            "Address 2 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address2 = "Address 2 must contain at least one letter";
        } else {
          fieldErrors.address2 = "";
        }
        break;

      case "address3":
        if (trimmedValue) {
          if (trimmedValue.length < 5 || trimmedValue.length > 150) {
            fieldErrors.address3 =
              "Address 3 must be between 5 and 150 characters";
          } else if (
            !/^[A-Za-z0-9,.\/#-][A-Za-z0-9,.\/# -]*[A-Za-z0-9,.\/#-]$/.test(
              trimmedValue,
            )
          ) {
            fieldErrors.address3 =
              "Address 3 contains invalid characters or starts/ends with spaces";
          } else if (!/[A-Za-z]/.test(trimmedValue)) {
            fieldErrors.address3 = "Address 3 must contain at least one letter";
          } else {
            fieldErrors.address3 = "";
          }
        } else {
          fieldErrors.address3 = "";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        } else {
          fieldErrors.pinCode = "";
        }
        break;

      case "firstContactPersonName":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonName =
            "Contact person name is required";
        } else if (
          // !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.firstContactPersonName =
            "Contact person name must be between 2 and 50 characters";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonName =
            "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.firstContactPersonName =
            "Contact person name cannot consist of the same letter repeated";
        } else {
          fieldErrors.firstContactPersonName = "";
        }
        break;

      case "firstContactPersonMobileNo":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonMobileNo =
            "Contact person mobile number is required";
        } else if (!/^[6789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
        } else if (/^(\d)\1{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot have all repeated digits";
        } else if (
          trimmedValue === "1234567890" ||
          trimmedValue === "9876543210"
        ) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot be a simple sequence";
        } else {
          fieldErrors.firstContactPersonMobileNo = "";
        }
        break;

      case "gstNumber":
        if (
          trimmedValue &&
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
            trimmedValue,
          )
        ) {
          fieldErrors.gstNumber = "Invalid GST Number format";
        } else {
          fieldErrors.gstNumber = "";

          if (trimmedValue.length === 15) {
            const derivedPan = trimmedValue.slice(2, 12);

            setPayloadData((prev) => ({
              ...prev,
              companyPanNumber: derivedPan,
            }));
          }
        }
        break;

      case "aadharNumber":
        const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";

        if (!aadharRaw) {
          fieldErrors.aadharNumber = "Aadhar Number is required";
        } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number must be exactly 12 digits and start with 2-9";
        } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number cannot have all repeated digits";
        } else {
          fieldErrors.aadharNumber = "";
        }
        break;

      case "panNumber":
      const panRaw = payloadData.panNumberRaw?.trim() || "";
    
      if (!panRaw) {
        fieldErrors.panNumber = "PAN Number is required";
      } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panRaw)) {
        fieldErrors.panNumber = "Invalid PAN Number format";
      } else if (
        isValidAuthPerPan &&
        payloadData?.companyPanNumber === panRaw
      ) {
        fieldErrors.panNumber =
          "LMBP PAN and Authorised PAN must be different";
      } else {
        fieldErrors.panNumber = "";
      }
      break;

      case "companyType":
        if (!trimmedValue) {
          fieldErrors.companyType = "LMBP Type is required";
        } else {
          fieldErrors.companyType = "";
        }
        break;

      case "hubCode":
        if (!trimmedValue && payloadData?.hierarchyType !== "SUB") {
          fieldErrors.hubCode = "HUB Type is required";
        } else {
          fieldErrors.hubCode = "";
        }
        break;

      case "rateCardId":
        if (!trimmedValue) {
          fieldErrors.rateCardId = "Rate Card Type is required";
        } else {
          fieldErrors.rateCardId = "";
        }
        break;

      case "isEcommerce":
        if (trimmedValue === "") {
          fieldErrors.isEcommerce = "Ecommerce selection is required";
        } else {
          fieldErrors.isEcommerce = "";
        }
        break;

      case "lmbpBusinessType":
        if (!trimmedValue) {
          fieldErrors.lmbpBusinessType = "LMBP Business Type is required";
        } else {
          fieldErrors.lmbpBusinessType = "";
        }

      case "masterLmbpCode":
        if (!trimmedValue && payloadData?.hierarchyType === "SUB" && payloadData?.parentType === "LMBP") {
          fieldErrors.masterLmbpCode = "Master LMBP Name is required";
        } else {
          fieldErrors.masterLmbpCode = "";
        }

      case "hierarchyType":
        if (!trimmedValue) {
          fieldErrors.hierarchyType = "Hierarchy Type is required";
        } else {
          fieldErrors.hierarchyType = "";
        }

      case "parentType":
        if (!trimmedValue) {
          fieldErrors.parentType = "Parent Type is required";
        } else {
          fieldErrors.parentType = "";
        }

      case "margin":
        if (!trimmedValue && payloadData?.hierarchyType === "SUB") {
          fieldErrors.margin = "Margin is required for SUB hierarchy type";
        } else {
          fieldErrors.margin = "";
        }

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setPayloadData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleCheckGstNumber = async () => {
    const gstNumber = payloadData?.gstNumber;

    if (!gstNumber || gstNumber.length !== 15) {
      CustomAlert({
        title: "Invalid GST",
        text: "Please enter a valid 15-digit GST Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_GST_STATUS}/${gstNumber}`,
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid GST",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidGSTNo(true);
        setGstApproved(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidGSTNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking GST number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleCheckConpanyPanNumber = async () => {
    const companyPanNumber = payloadData?.companyPanNumber;

    if (!companyPanNumber || companyPanNumber.length !== 10) {
      CustomAlert({
        title: "Invalid PAN",
        text: "Please enter a valid 10-digit PAN Number.",
        icon: "warning",
        confirmButtonText: "Okay",
      });
      return;
    }

    try {
      const response = await axiosGetApi(
        `${apiList.GET_COMPANY_PAN_STATUS}/${companyPanNumber}`,
      );

      const respCode = response?.data?.respCode;

      if (response?.data?.status && respCode === "00") {
        CustomAlert({
          title: response?.data?.message,
          // text: response?.data?.message || "GST Number exists.",
          icon: "info",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      } else if (respCode === "01") {
        CustomAlert({
          title: "Valid",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setValidCompanyPanNo(true);
        setPanApproved(true);
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.message,
          icon: "error",
          confirmButtonText: "Retry",
        });
        setValidCompanyPanNo(false);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while checking LMBP Pan number.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };
  const fieldDisabled = true;

  const isValidAuthPerPan =
    payloadData?.companyType === "Private Limited" ||
    payloadData?.companyType === "Public Limited" ||
    payloadData?.companyType === "LLP";

    const isReadOnly = isViewMode || isDeleteMode || isAuthMode || isEditMode;
    const isEditable = isViewMode || isDeleteMode || isAuthMode;

  const openDocument = (filePath, label = "Document") => {
    if (!filePath) {
      CustomAlert({
        title: `${label} Not Found`,
        text: `No ${label} document uploaded.`,
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    if (label.toLowerCase().includes("gst")) {
      setActiveDoc("GST");
    } else if (label.toLowerCase().includes("pan")) {
      setActiveDoc("PAN");
    }

    // determine simple mime / extension
    const ext = (filePath.split(".").pop() || "").toLowerCase();
    setDocMime(ext);
    setDocPath(filePath);
    setDocLabel(label);
    setShowDocModal(true);
  };

  const closeDocumentModal = () => {
    setShowDocModal(false);
    setDocPath("");
    setDocLabel("");
    setDocMime("");
  };

  const fetchRateCardData = async () => {
    if (cardOptions.length > 0) return;

    try {
      const response = await axiosGetApi(
        `${apiList.ALL_RATE_CARD_DATA}?username=${loggedInUserName}`,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setCardOptions(response.data.data);
      }
    } catch (err) {
      console.error("Rate Card fetch error", err);
    }
  };

  const fetchActiveLmbpData = async () => {
        // setApiLoading(true);
        try {
          const response = await axiosGetApi(
            `${apiList.FETCH_ALL_MASTER_LMBP_LIST}?username=${loggedInUserName}`,
          );
    
          if (response?.status === 200) {
            setLmbpList(response?.data?.data);
            // setApiLoading(false);
          }
        } catch (error) {
          console.error("Error fetching LMBP data:", error);
          // setApiLoading(false);
        } finally {
          // setApiLoading(false);
        }
  };

  const lmbpTypeOptions = [
    { label: "Master", value: "MASTER" },
    { label: "Sub", value: "SUB" },
  ];

  const parentTypeOptions = [
    { label: "HUB", value: "HUB" },
    { label: "LMBP", value: "LMBP" },
  ];

  const gstFilePath = editData?.gstCertificateFilePath;
  const panFilePath = editData?.panTanFilePath;

  return (
    <>
      <form>
        <div className="modal-body">
          {["view", "auth", "modify", "delete"].includes(action) && (
            <div className="row mb-3">
              <div className="col-12 text-center">
                <h5>LMBP Id - {payloadData.customerCode}</h5>
              </div>
            </div>
          )}

          {/* GST Number & LMBP PAN No on the same row */}
          <div className="row mb-3">
            {/* GST Number */}
            <div className="col-md-6">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label
                  htmlFor="gstNumber"
                  style={{ width: "150px" }}
                  className="text-sm font-medium text-gray-700"
                >
                  GST Number
                </label>

                <div className="relative flex-grow">
                  <i className="fa fa-file-invoice absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] !rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="GST Number"
                    id="gstNumber"
                    value={ !isViewMode ? 
                      payloadData.gstNumber : (
                        payloadData.gstNumber
                        ? payloadData.gstNumber
                            .split("")
                            .map((char, i) => (i >= 7 && i <= 10 ? "*" : char))
                            .join("")
                        : ""
                      )}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || isEditMode
                    }
                    maxLength={15}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>

                {!isViewMode && !isAuthMode ? (
                  gstApproved ? (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#16A34A",
                        borderColor: "#16A34A",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        cursor: "default",
                        transition: "all 0.3s ease",
                        fontWeight: 500,
                      }}
                      disabled
                    >
                      Approved
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleCheckGstNumber}
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#FF6A13",
                        borderColor: "#FF6A13",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                      }}
                      disabled={action !== "add"}
                    >
                      Check
                    </button>
                  )
                ) : (
                  <FaEye
                    className="text-gray-600 cursor-pointer hover:text-orange-500"
                    onClick={() => openDocument(gstFilePath, "GST Certificate")}
                  />
                )}
              </div>
            </div>

            {/* LMBP PAN No */}
            <div className="col-md-6">
              <div
                className="form-group"
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <label
                  htmlFor="companyPanNumber"
                  style={{ width: "150px" }}
                  className="text-sm font-medium text-gray-700"
                >
                  LMBP PAN No
                </label>

                <div className="relative flex-grow">
                  <i className="fa fa-id-card absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="LMBP PAN No"
                    id="companyPanNumber"
                    // value={payloadData.companyPanNumber}
                    value={
                      payloadData.companyPanNumber
                        ? payloadData.companyPanNumber
                            .split("")
                            .map((char, i) => (i >= 5 && i <= 8 ? "*" : char))
                            .join("")
                        : ""
                    }
                    disabled={isViewMode || isDeleteMode || isAuthMode}
                    maxLength={15}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>

                {!isViewMode && !isAuthMode ? (
                  panApproved ? (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#16A34A",
                        borderColor: "#16A34A",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        cursor: "default",
                        transition: "all 0.3s ease",
                        fontWeight: 500,
                      }}
                      disabled
                    >
                      Approved
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-submit"
                      style={{
                        height: "38px",
                        backgroundColor: "#FF6A13",
                        borderColor: "#FF6A13",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "0 18px",
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                      }}
                      onClick={handleCheckConpanyPanNumber}
                      disabled={action !== "add"}
                    >
                      Check
                    </button>
                  )
                ) : (
                  <FaEye
                    className="text-gray-600 cursor-pointer hover:text-orange-500"
                    onClick={() => openDocument(panFilePath, "PAN Document")}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Three-column grid for remaining fields */}
          <div className="grid grid-cols-3 items-center gap-3 mb-3 mt-1">
              <div className="form-group">
                <label
                  htmlFor="name"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  LMBP Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[36px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Enter LMBP Name"
                    id="name"
                    value={payloadData.name}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) && errors.name ? (
                  <span className="error">{errors.name}</span>
                ) : null}
              </div>
            
              <div className="form-group">
                <label
                  htmlFor="emailId"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  LMBP Email Id<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-envelope absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="email"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Enter LMBP Email Id"
                    id="emailId"
                    value={payloadData.emailId}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.emailId ? (
                  <span className="error">{errors.emailId}</span>
                ) : null}
              </div>

            <div>
              <label 
                className="text-sm font-medium text-gray-700 mb-1 block"
                htmlFor="hierarchyType"
              >
                Hierarchy Type
                <span style={{ color: "red" }}>*</span>
              </label>
              <Dropdown
                options={lmbpTypeOptions}
                value={payloadData.hierarchyType}
                labelKey="label"
                valueKey="value"
                placeholder="Select Hierarchy Type"
                onChange={(item) => {
              
                  handleInputChange({
                    target: {
                      id: "hierarchyType",
                      value: item.value,
                    },
                  });
                }}
                disabled={isReadOnly}
              />
            </div>

            <div>
              <label 
                className="text-sm font-medium text-gray-700 mb-1 block"
                htmlFor="parentType"
              >
                Parent Type
                <span style={{ color: "red" }}>*</span>
              </label>
              <Dropdown
                options={parentTypeOptions}
                value={payloadData.parentType}
                labelKey="label"
                valueKey="value"
                placeholder="Select Parent Type"
                onChange={(item) => {
              
                  handleInputChange({
                    target: {
                      id: "parentType",
                      value: item.value,
                    },
                  });
                }}
                disabled={isReadOnly || payloadData.hierarchyType === "MASTER"}
              />
            </div>

          {(payloadData?.hierarchyType === "MASTER" || payloadData?.parentType === "HUB") && (
            <div>
              {/* TODO */}
              {isViewMode || isDeleteMode || isAuthMode ? (
                <div className="form-group">
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Hub
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>
                    <input
                      type="text"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      placeholder="Contact Person Mobile No."
                      value={payloadData.hubName}
                      disabled
                    />
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <label
                    className="text-sm font-medium text-gray-700 mb-1 block"
                    htmlFor="hubCode"
                  >
                    Hub<span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>

                    <select
                      id="hubCode"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3
                                text-sm focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      value={payloadData.hubCode}
                      disabled={action === "view" || action === "delete"}
                      onChange={(e) => {
                        const selectedCode = e.target.value;
                        const selectedHub = hubList.find(
                          (hub) => hub.hubCode === selectedCode,
                        );

                        setPayloadData((prev) => ({
                          ...prev,
                          hubCode: selectedHub?.hubCode || "",
                          hubName: selectedHub?.hubName || "",
                        }));
                      }}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Hub</option>

                      {hubList.map((hub) => (
                        <option key={hub.hubCode} value={hub.hubCode}>
                          {hub.hubName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {errors?.hubCode && (
                    <span className="error">{errors.hubCode}</span>
                  )}
                </div>
              )}
            </div>
          )}

            {(payloadData?.hierarchyType === "SUB" && payloadData?.parentType === "LMBP") && (
              <div>
                <label 
                  htmlFor="masterLmbpCode" 
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Master LMBP List
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Dropdown
                  options={lmbpList}
                  value={payloadData.masterLmbpCode}
                  placeholder="Select Master LMBP"
                  onChange={(item) =>
                    setPayloadData((prev) => ({
                      ...prev,
                      masterLmbpCode: item.customerCode,
                      rateCardName: item.rateCardName,
                      rateCardId: item.rateCardId,
                      isEcommerce: item.isEcommerce,
                    }))
                  }
                  labelKey="name"
                  valueKey="customerCode"
                  disabled={isEditable}
                  error={errors.masterLmbpCode}
                />
              </div>
            )}

              <div className="form-group">
                <label
                  htmlFor="address1"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 1<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 1"
                    id="address1"
                    value={payloadData.address1}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.address1 ? (
                  <span className="error">{errors.address1}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="address2"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 2<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 2"
                    id="address2"
                    value={payloadData.address2}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.address2 ? (
                  <span className="error">{errors.address2}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="address3"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Address 3
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Address 3"
                    id="address3"
                    value={payloadData.address3}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="pinCode"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Pin Code<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Pin Code"
                    id="pinCode"
                    value={payloadData.pinCode}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,6}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.pinCode ? (
                  <span className="error">{errors.pinCode}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="state"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  State
                </label>
                <div className="relative">
                  <i className="fa fa-flag absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    id="state"
                    value={payloadData.state || "State"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="city"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  City
                </label>
                <div className="relative">
                  <i className="fa fa-city absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    id="city"
                    value={payloadData.city || "City"}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
              </div>
              <div className="form-group">
                <label
                  htmlFor="firstContactPersonName"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Contact Person Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-user absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Contact Person Name"
                    id="firstContactPersonName"
                    value={payloadData.firstContactPersonName}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={50}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[A-Za-z .-]*$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.firstContactPersonName ? (
                  <span className="error">{errors.firstContactPersonName}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="firstContactPersonMobileNo"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Contact Person Mobile No.
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <input
                    type="text"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    placeholder="Contact Person Mobile No."
                    id="firstContactPersonMobileNo"
                    value={payloadData.firstContactPersonMobileNo}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                  />
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.firstContactPersonMobileNo ? (
                  <span className="error">
                    {errors.firstContactPersonMobileNo}
                  </span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="companyType"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  LMBP Type<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <select
                    id="companyType"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    value={payloadData.companyType}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Select Type</option>
                    <option value="Proprietor">Proprietor</option>
                    <option value="Private Limited">Private Limited</option>
                    <option value="Individual">Individual</option>
                    <option value="LLP">LLP</option>
                    <option value="Public Limited">Public Limited</option>
                  </select>
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.companyType ? (
                  <span className="error">{errors.companyType}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="lmbpBusinessType"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  LMBP Business Type<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                  <select
                    id="lmbpBusinessType"
                    className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                    value={payloadData.lmbpBusinessType}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Select Type</option>
                    <option value="OUTLET">Outlet</option>
                    <option value="SELLER">Seller</option>
                  </select>
                </div>
                {!(isViewMode || isDeleteMode || isAuthMode) &&
                errors.lmbpBusinessType ? (
                  <span className="error">{errors.lmbpBusinessType}</span>
                ) : null}
              </div>
              <div className="form-group">
                <label
                  htmlFor="panNumber"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Authorize Person PAN No
                  <span style={{ color: "red" }}>*</span>
                </label>
            
                <PanInput
                  id="panNumber"
                  value={payloadData.panNumber}
                  onChange={(masked, raw) => {
                    setPayloadData((prev) => ({
                      ...prev,
                      panNumber: masked, // display value
                      panNumberRaw: raw, // actual value
                    }));
                  }}
                  onBlur={handleBlur}
                  disabled={
                    isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                  }
                  error={
                    !(isViewMode || isDeleteMode || isAuthMode) &&
                    errors.panNumber
                      ? errors.panNumber
                      : null
                  }
                />
              </div>
              <div className="form-group">
                <label
                  htmlFor="aadharNumber"
                  className="text-sm font-medium text-gray-700 mb-1 block"
                >
                  Aadhar Number<span style={{ color: "red" }}>*</span>
                </label>
                <div className="relative">
                  <i className="fa fa-id-badge absolute left-3 top-[9px] text-[#FF702B] text-sm"></i>
                  <AadhaarInput
                    id="aadharNumber"
                    value={payloadData.aadharNumber}
                    onChange={(masked, raw) => {
                      setPayloadData((prev) => ({
                        ...prev,
                        aadharNumber: masked, // for display
                        aadharNumberRaw: raw, // for validation
                      }));
                    }}
                    onBlur={handleBlur}
                    disabled={
                      isViewMode || isDeleteMode || isAuthMode || !fieldDisabled
                    }
                    error={
                      !(
                        isViewMode ||
                        isDeleteMode ||
                        isAuthMode ||
                        (action === "modify" && !payloadData.aadharNumberRaw)
                      ) && errors.aadharNumber
                        ? errors.aadharNumber
                        : null
                    }
                  />
                </div>
              </div>

            <div className="">
              {isViewMode || isDeleteMode || isAuthMode || (payloadData?.hierarchyType === "SUB" && payloadData.parentType === "LMBP") ? (
                <div className="form-group">
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Rate Card Type
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>
                    <input
                      type="text"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      placeholder="Select Rate Card Type"
                      value={payloadData.rateCardName}
                      disabled
                    />
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <label
                    className="text-sm font-medium text-gray-700 mb-1 block"
                    htmlFor="rateCardId"
                  >
                    Rate Card Type<span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>
                    <select
                      id="rateCardId"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3
                                text-sm focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      value={payloadData.rateCardId}
                      disabled={
                        isViewMode ||
                        isDeleteMode ||
                        isAuthMode ||
                        !fieldDisabled
                      }
                      onClick={fetchRateCardData}
                      onChange={(e) => {
                        const selectedCode = e.target.value;

                        const selectedRateCard = cardOptions.find(
                          (item) => item.rateCardId === selectedCode,
                        );

                        setPayloadData((prev) => ({
                          ...prev,
                          rateCardId: selectedRateCard?.rateCardId || "",
                          rateCardName: selectedRateCard?.rateCardName || "",
                        }));
                      }}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Rate Card Type</option>

                      {cardOptions.map((item) => (
                        <option key={item.rateCardId} value={item.rateCardId}>
                          {item.rateCardName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {errors?.rateCardId && (
                    <span className="error">{errors.rateCardId}</span>
                  )}
                </div>
              )}
            </div>

            {/* isEcommerce */}
            <div>
              {isViewMode || isDeleteMode || isAuthMode || payloadData?.hierarchyType === "SUB" && payloadData.parentType === "LMBP" ? (
                <div className="form-group">
                  <label className="text-sm font-medium text-gray-700 mb-1 block">
                    Ecommerce
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>
                    <input
                      type="text"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                              text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      placeholder="Select Ecommerce"
                      value={
                        payloadData.isEcommerce === true
                          ? "Yes"
                          : payloadData.isEcommerce === false
                          ? "No"
                          : ""
                      }
                      disabled
                    />
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <label
                    className="text-sm font-medium text-gray-700 mb-1 block"
                    htmlFor="isEcommerce"
                  >
                    Ecommerce<span style={{ color: "red" }}>*</span>
                  </label>

                  <div className="relative">
                    <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm">
                      {" "}
                    </i>
                    <select
                      id="isEcommerce"
                      className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3
                                text-sm focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                      value={
                        payloadData.isEcommerce === true
                          ? "Yes"
                          : payloadData.isEcommerce === false
                          ? "No"
                          : ""
                      }
                      disabled={
                        isViewMode ||
                        isDeleteMode ||
                        isAuthMode ||
                        !fieldDisabled
                      }
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Select Ecommerce</option>

                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  {errors?.isEcommerce && (
                    <span className="error">{errors.isEcommerce}</span>
                  )}
                </div>
              )}
            </div>

              {payloadData?.hierarchyType && (
                 <div className="form-group">
                   <label
                     htmlFor="margin"
                     className="text-sm font-medium text-gray-700 mb-1 block"
                   >
                     Margin (%)
                     {payloadData?.hierarchyType === "SUB" && <span style={{ color: "red" }}>*</span>}
                   </label>

                   <div className="relative">
                     <i className="fa fa-percent absolute left-3 top-3 text-[#FF702B] text-sm"></i>

                     <input
                       type="number"
                       id="margin"
                       min="0"
                       max="30"
                       step="0.01"
                       value={payloadData.margin ?? ""}
                       onChange={handleInputChange}
                       onBlur={handleBlur}
                       disabled={isEditable}
                       className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3
                                  text-sm focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                       placeholder={payloadData?.hierarchyType === "SUB" ? "e.g. 10" : "Usually 0"}
                     />
                   </div>
                   <small className="text-gray-500">
                     {payloadData?.hierarchyType === "SUB"
                       ? "On freight, added to the parent's rate (0–30%)"
                       : "On freight, all to Appan (0–30%)"}
                   </small>

                   {errors.margin && <span className="error">{errors.margin}</span>}
                 </div>
               )}

              {payloadData?.hierarchyType === "SUB" && (
                 <div className="form-group">
                   <label
                     htmlFor="marginCompanyShare"
                     className="text-sm font-medium text-gray-700 mb-1 block"
                   >
                     Company share of margin (%)
                     <span style={{ color: "red" }}>*</span>
                   </label>
                   <div className="relative">
                     <i className="fa fa-percent absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                     <input
                       type="number"
                       id="marginCompanyShare"
                       min="0"
                       max="100"
                       step="1"
                       value={payloadData.marginCompanyShare ?? 50}
                       onChange={handleInputChange}
                       disabled={isEditable}
                       className="w-full !h-[42px] rounded-lg border border-gray-300 pl-9 pr-3
                                  text-sm focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                     />
                   </div>
                   <small className="text-gray-500">The parent LMBP gets the rest (default 50/50)</small>
                   {errors.marginCompanyShare && <span className="error">{errors.marginCompanyShare}</span>}
                 </div>
               )}

              {payloadData?.hierarchyType === "SUB" && (
                 <div className="form-group">
                   <label
                     htmlFor="marginPayout"
                     className="text-sm font-medium text-gray-700 mb-1 block"
                   >
                     Pay the parent LMBP's share
                   </label>
                   <select
                     id="marginPayout"
                     value={payloadData.marginPayout || "BOOKING"}
                     onChange={handleInputChange}
                     disabled={isEditable}
                     className="w-full !h-[42px] rounded-lg border border-gray-300 px-3 text-sm
                                focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                   >
                     <option value="BOOKING">At booking</option>
                     <option value="DELIVERY">After delivery</option>
                   </select>
                 </div>
               )}
          </div>
        </div>
        <div className="scoped-modal modal-footer !justify-center gap-3">
          <button
            type="button"
            className="btn btn-back w-[133px] !rounded-lg"
            onClick={CloseCreate}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleNextWithValidation}
            className="btn btn-submit w-[133px] !rounded-lg"
          >
            Next
          </button>
          <DeleteConfirmationModal
            isOpen={isModalOpen}
            onClose={closeModal}
            editData={editData}
            fetchCustomerData={fetchCustomerData}
            handleClose={handleClose}
          />
        </div>

        {showDocModal && (
          <>
            <div
              className={`modal fade show`}
              tabIndex="-1"
              role="dialog"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
              }}
            >
              <div
                className="modal-dialog modal-lg"
                role="document"
                style={{ maxWidth: 900 }}
              >
                <div className="modal-content shadow-lg rounded-3 overflow-hidden">
                  {/* ---------------- Dynamic Header ---------------- */}
                  <div
                    style={{
                      backgroundColor: "#FFF4EE",
                      padding: "20px 0 16px",
                      borderBottom: "1px solid #FFD8C2",
                      position: "relative",
                      textAlign: "center",
                    }}
                  >
                    {/* Header content based on activeDoc */}
                    {activeDoc === "GST" && (
                      <div>
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            backgroundColor: "#FF6A13",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            fontSize: "22px",
                            margin: "0 auto 8px",
                            boxShadow: "0 3px 6px rgba(255,106,19,0.4)",
                          }}
                        >
                          <i className="fa fa-file-invoice"></i>
                        </div>
                        <h5
                          style={{
                            color: "#FF6A13",
                            fontWeight: 600,
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        >
                          GST Number
                        </h5>
                        <p style={{ fontSize: "13px", color: "#555" }}>
                          {payloadData?.gstNumber || "—"}
                        </p>
                      </div>
                    )}

                    {activeDoc === "PAN" && (
                      <div>
                        <div
                          style={{
                            width: "54px",
                            height: "54px",
                            backgroundColor: "#FF6A13",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "#fff",
                            fontSize: "22px",
                            margin: "0 auto 8px",
                            boxShadow: "0 3px 6px rgba(255,106,19,0.4)",
                          }}
                        >
                          <i className="fa fa-id-card"></i>
                        </div>
                        <h5
                          style={{
                            color: "#FF6A13",
                            fontWeight: 600,
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        >
                          LMBP PAN No
                        </h5>
                        <p style={{ fontSize: "13px", color: "#555" }}>
                          {payloadData?.companyPanNumber || "—"}
                        </p>
                      </div>
                    )}

                    {/* Close button */}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={closeDocumentModal}
                      style={{
                        position: "absolute",
                        top: "14px",
                        right: "18px",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        padding: "6px",
                        width: "32px",
                        height: "32px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                      }}
                    ></button>
                  </div>

                  {/* ---------- Document Preview Section ---------- */}
                  <div
                    className="modal-body"
                    style={{
                      minHeight: 240,
                      display: "flex",
                      flexDirection: "column",
                      gap: 12,
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    {/* Zoom controls and preview area */}
                    <div
                      style={{
                        position: "relative",
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#fff",
                        borderRadius: "8px",
                        padding: "12px",
                        overflow: "hidden",
                      }}
                    >
                      {/* Zoom Icons */}
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "16px",
                          display: "flex",
                          gap: "10px",
                          zIndex: 10,
                        }}
                      >
                        {/* Zoom Icons */}
                        <div
                          style={{
                            position: "absolute",
                            top: "12px",
                            right: "16px",
                            display: "flex",
                            gap: "10px",
                            zIndex: 10,
                          }}
                        >
                          {/* 🔍 Zoom In */}
                          <button
                            type="button"
                            onClick={() =>
                              setZoomLevel((prev) => Math.min(prev + 0.25, 3))
                            }
                            style={{
                              backgroundColor: "#FF6A13",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-search-plus"></i>
                          </button>

                          {/* ↺ Reset Zoom */}
                          <button
                            type="button"
                            onClick={() => {
                              const preview =
                                document.getElementById("doc-preview");
                              if (preview) {
                                preview.style.transition =
                                  "transform 0.3s ease, opacity 0.2s ease";
                                preview.style.opacity = "0.7";
                                setTimeout(() => {
                                  setZoomLevel(1);
                                  setOffset({ x: 0, y: 0 });
                                  preview.style.opacity = "1";
                                }, 150);
                              } else {
                                setZoomLevel(1);
                                setOffset({ x: 0, y: 0 });
                              }
                            }}
                            style={{
                              backgroundColor: "#999",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-undo"></i>
                          </button>

                          {/* 🔍 Zoom Out */}
                          <button
                            type="button"
                            onClick={() =>
                              setZoomLevel((prev) => Math.max(prev - 0.25, 0.5))
                            }
                            style={{
                              backgroundColor: "#FF6A13",
                              color: "#fff",
                              border: "none",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                              transition: "transform 0.2s ease",
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <i className="fa fa-search-minus"></i>
                          </button>
                        </div>
                      </div>

                      {/* Document Preview */}
                      <div
                        id="doc-preview"
                        onMouseDown={handleMouseDown}
                        style={{
                          transform: `scale(${zoomLevel}) translate(${
                            offset.x / zoomLevel
                          }px, ${offset.y / zoomLevel}px)`,
                          transformOrigin: "center center",
                          transition: isDragging
                            ? "none"
                            : "transform 0.25s ease",
                          cursor:
                            zoomLevel > 1
                              ? isDragging
                                ? "grabbing"
                                : "grab"
                              : "default",
                        }}
                      >
                        {docMime === "pdf" ? (
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(
                              docPath,
                            )}&embedded=true`}
                            title={docLabel}
                            style={{
                              width: "100%",
                              height: "60vh",
                              border: "none",
                              borderRadius: "8px",
                            }}
                          />
                        ) : [
                            "png",
                            "jpg",
                            "jpeg",
                            "gif",
                            "webp",
                            "bmp",
                          ].includes(docMime) ? (
                          <img
                            src={docPath}
                            alt={docLabel}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "60vh",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <p>No preview available for this file type.</p>
                            <p style={{ fontSize: 13, color: "#666" }}>
                              {
                                (
                                  docPath.split("fileName=")[1] ||
                                  docPath.split("/").pop() ||
                                  ""
                                ).split("?")[0]
                              }
                            </p>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Meta + Actions */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 12,
                        marginTop: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          color: "#333",
                          minWidth: "450px",
                          maxWidth: "680px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={
                          (
                            docPath.split("fileName=")[1] ||
                            docPath.split("/").pop() ||
                            ""
                          ).split("?")[0]
                        }
                      >
                        <div>
                          <strong>File:</strong>{" "}
                          {
                            (
                              docPath.split("fileName=")[1] ||
                              docPath.split("/").pop() ||
                              ""
                            ).split("?")[0]
                          }
                        </div>
                        <div>
                          <strong>Type:</strong> {docMime || "unknown"}
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: 8 }}>
                        <a
                          href={docPath}
                          download
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-submit"
                          style={{ height: 38 }}
                        >
                          Download
                        </a>
                        <button
                          type="button"
                          className="btn btn-back"
                          onClick={closeDocumentModal}
                          style={{ height: 38 }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* backdrop */}
            <div className="modal-backdrop fade show"></div>
          </>
        )}
      </form>
    </>
  );
};

export default AddCustomer;
